import { useModalState } from "./hooks/useModalState";
import { jsx as _jsx } from "react/jsx-runtime";
export function ModalManager() {
  var modals = useModalState();
  return /*#__PURE__*/_jsx("div", {
    id: "modal-root",
    children: modals
  });
}